var _defs, _line, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".back-a,.back-b{fill:none;stroke:#bfbfbf;stroke-width:2px;}.back-b{stroke-linecap:round;stroke-linejoin:round;}.back-c{clip-path:url(#back-a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "back-a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "back-a",
    width: 31,
    height: 31
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "back-b",
    x2: 10.492,
    transform: "translate(10.588 15.501)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "back-b",
    d: "M12.676,18.081,8,13.4l4.676-4.676",
    transform: "translate(1.92 2.095)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "back-c"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "back-b",
    cx: 14.88,
    cy: 14.88,
    r: 14.88,
    transform: "translate(0.62 0.62)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.f5278720.svg";
export { ForwardRef as ReactComponent };